import {
  Box,
  StackProps,
  useDisclosure,
  useOutsideClick,
  VStack,
} from '@chakra-ui/react';
import { Block, ColorResult } from '@uiw/react-color';
import { useRef, useState } from 'react';

export type ColorPickerProps = StackProps & {
  colors?: string[];
  defaultColor?: string;
  onColorChange?: (color: ColorResult) => void;
};

export default function ColorPicker({
  onColorChange,
  defaultColor = '#000000',
  colors,
  ...props
}: ColorPickerProps) {
  const ref = useRef();
  const [color, setColor] = useState(defaultColor);
  const { isOpen, onToggle, onClose } = useDisclosure();

  useOutsideClick({
    ref,
    handler: onClose,
  });

  return (
    <VStack pos="relative" w="100px" {...props}>
      <Box
        w="full"
        h="30px"
        boxShadow="button"
        borderRadius="5px"
        bgColor={color}
        onClick={onToggle}
        cursor="pointer"
      />

      {isOpen && (
        <Box ref={ref} pos="absolute" transform="translateY(40px)" zIndex={1}>
          <Block
            color={color}
            onChange={(color) => {
              setColor(color.hex);
              onClose();
              if (onColorChange) onColorChange(color);
            }}
            colors={colors}
          />
        </Box>
      )}
    </VStack>
  );
}
